module.exports = __webpack_public_path__ + "static/media/step4.250d9aed.png";